module.exports = __webpack_public_path__ + "img/zztbg-1.8f49d5f7.png";